module.exports = {
    Hosts : { // Router com a mensageria do P&D
        "host": "https://apontamento.grv.net.br:9080",
        "host_alt1": "http://ws.grv.net.br:9080",
        "host_alt2": "http://ws1.grv.net.br:9080",
        "host_alt3": "http://ws2.grv.net.br:9080"
    }
}

